// extracted by mini-css-extract-plugin
export default {"main":"NivelAsignaturaSelector_main__RmG97"};